import { createNames } from "@ace/web-components/dist_lib/utils";
export const getAceBettingFilterBarNames = (id) => {
    return createNames(id, 'ACE-BETTING-FILTER-BAR', '____WITH_FILTER_BUTTON', '____GRID_VARIANT', '____FILTER_MODAL_OPEN', 'FILTERS__SLOTS', 'FILTERS__SLOTS__EL', 'FILTERS__BAR', 'FILTERS__BOTTOM_TRAY', 'FILTERS__BOTTOM_TRAY__HEADLINE', 'FILTERS__BOTTOM_TRAY__ITEMS', 'FILTERS__BOTTOM_TRAY__ITEMS__EL', 'FILTERS__BOTTOM_TRAY__ITEMS__EL____SELECTED', 'FILTERS__BUTTON', 'SORT__BOTTOM_TRAY', 'SORT__BOTTOM_TRAY__ITEMS', 'SORT__BOTTOM_TRAY__ACTIONS', 'SORT__ITEMS', 'SORT__ITEMS__EL', 'SORT__ITEMS__EL____SELECTED', 'SORT__BUTTON');
};
export const aceBettingFilterBarSlots = {
    FIRST_FILTER: 'first-filter',
    SECOND_FILTER: 'second-filter',
    THIRD_FILTER: 'third-filter',
    FOURTH_FILTER: 'fourth-filter',
};
//# sourceMappingURL=ace-betting-filter-bar.get-names.js.map
